import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OjtSloPaginationType, OjtSlotListType } from '../../services/ojtSlotting'

export interface OJTSlottingInitialStateType {
  isLoading: boolean
  dialogState: {
    type: 'offDay' | 'upsert' | 'location' | ''
    dayNumber?: number
    selectedRole?: string
    selectedLocationId?: number
  }
  ojtSlotList: OjtSlotListType[]
  pagination: OjtSloPaginationType
  offDayOjtSlotList: number[]
}

const initialState: OJTSlottingInitialStateType = {
  isLoading: false,
  dialogState: {
    type: '',
    dayNumber: 1,
    selectedRole: '',
    selectedLocationId: 0,
  },
  ojtSlotList: [],
  pagination: {
    prev_cursor: '',
    next_cursor: '',
    page_size: '10',
  },
  offDayOjtSlotList: [],
}

export const sliceName = 'ojtSlotting'

const appSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<OJTSlottingInitialStateType['isLoading']>) => {
      state.isLoading = action.payload
    },
    setDialogState: (state, action: PayloadAction<OJTSlottingInitialStateType['dialogState']>) => {
      state.dialogState = action.payload
    },
    setOjtSlotList: (state, action: PayloadAction<OJTSlottingInitialStateType['ojtSlotList']>) => {
      state.ojtSlotList = action.payload
    },
    setRoleOffDay: (state, action: PayloadAction<{ role: string; off_day: number[] }>) => {
      state.ojtSlotList = state.ojtSlotList.map((slot) => {
        if (slot.role === action.payload.role) {
          return {
            ...slot,
            off_day: action.payload.off_day,
          }
        }

        return slot
      })
    },
    setPagination: (state, action: PayloadAction<OjtSloPaginationType>) => {
      state.pagination = action.payload
    },
    setOffDayOjtSlotList: (state, action: PayloadAction<number[]>) => {
      state.offDayOjtSlotList = action.payload
    },
  },
})

export const {
  setLoading,
  setDialogState,
  setOjtSlotList,
  setPagination,
  setRoleOffDay,
  setOffDayOjtSlotList,
} = appSlice.actions

export default appSlice.reducer
